import React, { FC, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import Djs from './Djs';
import HostsGuests from './HostsGuests';
import AddPeopleTimelineButton from 'components/events/buttons/AddPeopleTimelineButton';

import useStyles from './style';

const People: FC = () => {
  const classes = useStyles();

  const [leftShadow, setLeftShadow] = useState(false);
  const [rightShadow, setRightShadow] = useState(false);

  const scrollRef = useRef<Nullable<HTMLDivElement>>(null);

  useEffect(() => {
    if (scrollRef.current && scrollRef.current?.scrollWidth > scrollRef.current?.offsetWidth) {
      setRightShadow(true);
    }
  }, []);

  return (
    <div className={classes.people}>
      <AddPeopleTimelineButton />
      <div
        className={classNames('users-line', {
          leftShadow,
          rightShadow,
        })}
      >
        <div
          ref={scrollRef}
          onScroll={e => {
            const leftScrolled = e.currentTarget.scrollLeft;
            const rightScrolled =
              e.currentTarget.scrollWidth -
              e.currentTarget.clientWidth -
              e.currentTarget.scrollLeft;

            if (rightScrolled <= 0 && !!rightShadow) {
              setRightShadow(false);
            } else if (!rightShadow) {
              setRightShadow(true);
            }

            if (leftScrolled <= 0 && !!leftShadow) {
              setLeftShadow(false);
            } else if (!leftShadow) {
              setLeftShadow(true);
            }
          }}
          className="scrollArea"
        >
          <Djs />
          <HostsGuests />
        </div>
      </div>
    </div>
  );
};

export default People;
